<template>
  <div style="height: 800px;background: #13161B;">

    <!-- 列表开始 -->
    <div class="BlockList" v-show="flag">
      <div class="BlockList-Wss">
        <div class="email_img">
          <img src="../../../assets/pc/Logo/email.png" />
        </div>
        <div class="email_tit">Congratulations!</div>
        <div class="email_tit1">
          <span style="word-spacing: -4px;">You've</span> successfully activated your<br />
          account!
        </div>
        <div class="email_cont1" @click="LogIn">
          Go to sign ln<img src="../../../assets/pc/Logo/left.png" />
        </div>
      </div>
    </div>
    <!-- 列表结束 -->
    <!-- 邮箱未激活页面 -->
    <div class="BlockList" v-show="flag1">
      <div class="BlockList-Wss">
        <div class="email_img">
          <img src="../../../assets/pc/Logo/email1.png" />
        </div>
        <div class="email_tit2">Activation failed</div>
        <div class="email_tit1">
          Activation link has expired, please<br/> re-register
        </div>
        <div class="email_cont" @click="Register">
          Register<img src="../../../assets/pc/Logo/left.png" />
        </div>
      </div>
     
    </div>
    <!-- 邮箱激活点击之后提示 -->
    <div class="BlockList" v-show="flag2">
      <div class="BlockList-Wss" style="height: 357px !important;">
        <div class="email_img">
          <img src="../../../assets/pc/Logo/email.png" />
        </div>
        <div class="email_tit11" style="font-size: 24px;
font-family: Roboto, Roboto;
font-weight: 500;line-height: 30px">Your account is already<br/> verified</div>
        <div class="email_tit1" style="margin-top:60px;font-size: 14px;
font-family: Roboto, Roboto;
font-weight: 400;
color: rgba(255,255,255,0.8);
line-height: 21px">
          You may proceed to log in with<br/> your Email and password.
    
        </div>
        <div class="email_cont1" @click="LogIn">
          Go to sign ln<img src="../../../assets/pc/Logo/left.png" />
        </div>
      </div>
    </div>
    <Signup
          v-show="flogb"
          :flogb="flogb"
          :floag="floag"
          @signups="signups($event)"
          @loginflog="loginflog($event)"
        ></Signup>
        <Login
          v-show="floag"
          :flogb="flogb"
          :flogc="flogc"
          :floag="floag"
          @loginflog="loginflog($event)"
          @signups="signups($event)"
          @repwd="repwd($event)"
          @emails="emails($event)"
        ></Login>
        <Resignup
          v-show="flogc"
          :flogc="flogc"
          :floag="floag"
          @repwd="repwd($event)"
          @back="back($event)"
        ></Resignup>
     <!-- 邮箱激活点击之后提示 -->
    <!-- <Login
          v-show="floag"
          :floag="floag"
          @loginflog="loginflog($event)"
        ></Login>
        <Signup
          v-show="flogb"
          :flogb="flogb"
          @signups="signups($event)"
        ></Signup> -->
    <!-- 邮箱未激活页面 -->
  </div>
</template>

<script>
import Signup from "./Signup.vue";
import Login from "./Login.vue";
import Resignup from "./Resignup.vue";
import { activateUser } from "@/assets/server/api";
export default {
  data() {
    return {
      flag: false,
      flag1: false,
      flag2:false,
      emailValue:'',   
      flogb:false,//注册
      floag:false,//登录
      
      flogc: false, //重置密码
    };
  },

  components: {
    Signup,
    Login,
    Resignup
  },
  created() {},
  mounted() {
    this.emailValue = this.$route.query.email;
  //  console.log(this.emailValue);
    this.Create();
    // this.BlockList();
  },
  methods: {
    async Create() {
      const params = {
        email: this.emailValue,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await activateUser(formData);
    //  console.log(data);
      if (data.code == 200 && data.result=="success") {
        this.flag=true;
      //  this.$message(data.result);
      //  this.emails = data.result;
      }else if(data.code ==200 && data.result=="User exists!"){
        this.flag2=true;
      //  this.$message(data.result);
      }else if(data.code==400){
        this.flag1=true;
       // this.$message(data.result);
      }
         
    },
    Register(){
    // console.log('点击注册');
     
     this.flogb=true;
    
    // this.flag1=false;
    //  this.$router.push("/pc/Index");
      // this.flaga=true;
      // this.$emit("signups", this.flaga);
    },
    LogIn(){
   //   console.log('点击登录');
      this.floag=true;
    },
    signups(val) {
   //   console.log("接受注册传过来的值", val);
      this.flogb = val;
    },
    loginflog(val) {
   //   console.log("接受login的值", val);
      this.floag = val;
    },
    back() {
      this.flogc = false;
      this.floag = true;
    },
    login() {
      this.floag = true;
    },
    emails(val) {
      this.userEmail = val;
    },
    signups(val) {
  //    console.log("接受注册传过来的值", val);
      this.flogb = val;
    },
    loginflog(val) {
   //   console.log("接受login的值", val);
      this.floag = val;
    },
    repwd(val) {
   //   console.log("接受重置repwd的值", val);
      this.flogc = val;
      this.floag=false;
    },
  },
};
</script>


<style lang="less" scoped>
.BlockList {
  position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 9999;
  // // height: 1000px !important;
  // background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  overflow: auto;
 
 
  .BlockList-Wss {
    width: 357px;
    height: 307px;
    background: #0b0c0f;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .email_img {
      margin-top: 43px;
      margin-left: 139px;
      img {
        width: 79px;
        height: 64px;
      }
    }
    .email_tit2 {
      margin-top: 26px;
      // margin-left: 187px;
      height: 20px;
      font-size: 24px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #E7435B;
      line-height: 20px;
      text-align: center;
    }
    .email_tit11{
      margin-top: 26px;
      // margin-left: 187px;
      height: 20px;
      font-size: 20px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #00e79a;
      line-height: 20px;
      text-align: center;
    }
    .email_tit {
      margin-top: 26px;
      // margin-left: 187px;
      height: 20px;
      font-size: 24px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #00e79a;
      line-height: 20px;
      text-align: center;
    }
    .email_tit1 {
      margin-top: 12px;
      height: 42px;
      font-size: 14px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 21px;
      text-align: center;
    }
    .email_cont1 {
      margin-top: 32px;
      height: 21px;
      font-size: 15px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 21px;
      // margin-left: 132px;
      position:absolute;
      left: 50%;
      transform: translate(-50%,0);
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin-top: 5px;
        cursor: pointer;
      }
    }
    .email_cont {
      margin-top: 32px;
      height: 21px;
      font-size: 15px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 21px;
      margin-left: 146px;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin-top: 5px;
      }
    }
  }
}
</style>
</style>
